import ProductAttribute from "./productAttribute";
import TotalPrice from "./totalPrice";
import ProductImage from "./productImage";
import ProductAttributeValue from "./productAttributeValue";

export default class Product {
    constructor(data, parentProduct = null, translateService) {
        this.width = 0;
        this.height = 0;
        this.length = 0;
        this.weight = 0;
        this.prices = {
            currency: {},
            price: 0,
            promo_price: 0,
            tax_rate: 1
        };
        this.variants = null;
        this.images = [];
        this.parentProduct = parentProduct;
        this.translate = translateService;
        this.counter = 0;

        Object.assign(this, data);

        let variants = [];
        Object.assign(variants, this.variants);

        if (variants) {
            this.variants = [];
            variants.forEach(variant => {
                this.variants.push(new Product(variant, this, this.translate));
                if (!this.prices.currency) {
                    this.prices.currency = variant.prices.currency;
                }
            });
        }

        let images = [];
        Object.assign(images, this.images);

        if(data.images) {
            this.images = [];
            data.images.forEach(image => {
                this.images.push(new ProductImage(image, this.id));
            });
        }

        let attributes = new Map();
        if (this.attributes) {
            this.attributes.forEach(productAttributeData => {
                attributes.set(productAttributeData.attribute.id, new ProductAttribute(this, productAttributeData));
            });
            this.attributes = attributes;
        }

        let productAttributeValues = [];

        if (this.attribute_values_data) {
            this.attribute_values_data.forEach(attributeValueData => {
                const attribute = attributeValueData.product_attribute ? this.attributes.get(attributeValueData.product_attribute.attribute.id) : null;
                const productAttributeValue = new ProductAttributeValue(attributeValueData, attribute);
                if (productAttributeValue.attributeId) {
                    this.attributes.get(productAttributeValue.attributeId).addProductAttributeValue(productAttributeValue);
                } else {
                    productAttributeValues.push(productAttributeValue);
                }
            });
        }

        let idx = 0;
        if (this.attributes) {
            this.attributes.forEach(attribute => {
                attribute.sortValues();
                for (let pav of attribute.productAttributeValues) {
                    pav.index = idx;
                    idx++;
                }
            });
        }

        // Attribute values assigned to the product without being assigned to the attribute
        if(productAttributeValues.length > 0) {
            attributes.set(0, new ProductAttribute(this, {
                attribute: {id: 0, name: ''},
                multiple: true
            }));
            productAttributeValues.forEach(productAttributeValue => attributes.get(0).addProductAttributeValue(productAttributeValue));
            attributes.get(0).sortValues();
            for (let pav of attributes.get(0).productAttributeValues) {
                pav.index = idx;
                idx++;
            }
        }

        this.allImages = this.getAllImages();
    }

    get shortDescription() {
        let description = [];

        if (this.height) {
            description.push(this.translate.t('height_shortcut') + ' ' + this.height + ' mm');
        }
        if (this.width) {
            description.push(this.translate.t('width_shortcut') + ' ' + this.width + ' mm');
        }
        if (this.length) {
            description.push(this.translate.t('depth_shortcut') + ' ' + this.length + ' mm');
        }
        if (this.weight) {
            description.push(this.translate.t('weigth') + ' ' + this.weight + ' kg');
        }

        return description.join(' | ');
    }

    addCounter() {
        this.counter++;
    }

    // Get all attributes from the product and it's variants
    get availableAttributes() {
        let allAttributes = Array.from(this.attributes);

        if (this.variants) {
            this.variants.forEach(variant => {
                if (variant.attributes) {
                    allAttributes = allAttributes.concat(Array.from(variant.attributes));
                }
            });
        }

        return allAttributes.map(attribute => attribute[1]);
    }

    // Get product and variants images
    getAllImages() {
        let images = this.images;
        this.images.sort((image1, image2) => {
            if (image1.default) {
                return -1;
            }
            if (image2.default) {
                return 1;
            }
            if (image1.pos > image2.pos) {
                return 1;
            } else {
                return -1;
            }
        });

        this.variants.forEach(variant => {
            images = images.concat(variant.allImages);
        });

        return images;
    }

    // Get product price as total price object
    getPrice() {
        let totalPrice = new TotalPrice(this.prices.currency, this.prices.tax_rate);

        totalPrice.price.add(this.prices.price);
        totalPrice.promoPrice.add(this.prices.promo_price ? this.prices.promo_price : this.prices.price);

        return totalPrice;
    }

    // Get selected product attributes price
    getTotalAttributesPrice() {
        if (!this.attributes) {
            return;
        }

        let totalPrice = new TotalPrice(this.prices.currency, this.prices.tax_rate);

        this.attributes.forEach(productAttribute => {
            totalPrice.sum(productAttribute.getTotalPrice());
        });

        return totalPrice;
    }

    // Get product price and selected product attributes price
    getTotalPrice() {
        let totalPrice = this.getPrice();

        totalPrice.sum(this.getTotalAttributesPrice());

        return totalPrice;
    }

    get hasIndividualAttributeValue() {
        return !!this.availableAttributes.find(attribute => attribute.hasSelectedIndividualAttributeValue);
    }

}
